import { PageTypeKeys } from './types';

export function setForceHideNav(forceHideNav: boolean) {
  return {
    type: PageTypeKeys.SET_FORCE_HIDE_NAV,
    forceHideNav,
  };
}
